import React from 'react';

/**
 * Hayat Design System - Input Component
 * Phase 15.1
 */

const Input = React.forwardRef(({ 
  type = 'text',
  error = false,
  disabled = false,
  className = '',
  ...props 
}, ref) => {
  const baseStyles = 'w-full px-3 py-2 rounded-hayat-sm border bg-neutral-900/80 backdrop-blur-xl text-hayat-neutral-800 placeholder-hayat-neutral-400 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-0 disabled:opacity-50 disabled:cursor-not-allowed';
  
  const stateStyles = error 
    ? 'border-hayat-danger-500 focus:border-hayat-danger-500 focus:ring-hayat-danger-500'
    : 'border-hayat-neutral-300 focus:border-hayat-primary-500 focus:ring-hayat-primary-500';
  
  return (
    <input
      ref={ref}
      type={type}
      className={`${baseStyles} ${stateStyles} ${className}`}
      disabled={disabled}
      {...props}
    />
  );
});

Input.displayName = 'Input';

export default Input;